export const snapfishActionTypes = {
    SNAPFISH_CUSTOM_COLLECTION_REQUEST: 'SNAPFISH_CUSTOM_COLLECTION_REQUEST',
    SNAPFISH_CUSTOM_COLLECTION_SUCCESS: 'SNAPFISH_CUSTOM_COLLECTION_SUCCESS',
    SNAPFISH_CUSTOM_COLLECTION_FAILURE: 'SNAPFISH_CUSTOM_COLLECTION_FAILURE',
    SNAPFISH_CUSTOM_COLLECTION_WAIT: 'SNAPFISH_CUSTOM_COLLECTION_WAIT',

    SNAPFISH_PHOTO_ELEMENTS_REQUEST: 'SNAPFISH_PHOTO_ELEMENTS_REQUEST',
    SNAPFISH_PHOTO_ELEMENTS_SUCCESS: 'SNAPFISH_PHOTO_ELEMENTS_SUCCESS',
    SNAPFISH_PHOTO_ELEMENTS_FAILURE: 'SNAPFISH_PHOTO_ELEMENTS_FAILURE',
    SNAPFISH_PHOTO_ELEMENTS_WAIT: 'SNAPFISH_PHOTO_ELEMENTS_WAIT',

    SNAPFISH_RETRIEVE_SELECTED_PHOTOS_REQUEST: 'SNAPFISH_RETRIEVE_SELECTED_PHOTOS_REQUEST',
    SNAPFISH_RETRIEVE_SELECTED_PHOTOS_SUCCESS: 'SNAPFISH_RETRIEVE_SELECTED_PHOTOS_FAILURE',
    SNAPFISH_RETRIEVE_SELECTED_PHOTOS_FAILURE: 'SNAPFISH_RETRIEVE_SELECTED_PHOTOS_FAILURE',

    SNAPFISH_CLEAR_SELECTED_PHOTOS: 'SNAPFISH_CLEAR_SELECTED_PHOTOS',
    SNAPFISH_CLEAR_PHOTO_ELEMENTS: 'SNAPFISH_CLEAR_PHOTO_ELEMENTS',
    SNAPFISH_SELECT_ITEM: 'SNAPFISH_SELECT_ITEM',
    SNAPFISH_DESELECT_ITEM: 'SNAPFISH_DESELECT_ITEM',
    SNAPFISH_SET_CURRENT_ALBUM_ID: 'SNAPFISH_SET_CURRENT_ALBUM_ID',

    SNAPFISH_SAVE_SELECTION_REQUEST: 'SNAPFISH_SAVE_SELECTION_REQUEST',
    SNAPFISH_SAVE_SELECTION_SUCCESS: 'SNAPFISH_SAVE_SELECTION_SUCCESS',
    SNAPFISH_SAVE_SELECTION_FAILURE: 'SNAPFISH_SAVE_SELECTION_FAILURE',

    SNAPFISH_SEND_SUCCESS: 'SNAPFISH_SEND_SUCCESS',
    SNAPFISH_SEND_FAILURE: 'SNAPFISH_SEND_FAILURE',

    SNAPFISH_SET_ALBUM_VIEW_MODE: 'SNAPFISH_SET_ALBUM_VIEW_MODE',
    SNAPFISH_SET_UPLOAD_VIEW_MODE: 'SNAPFISH_SET_UPLOAD_VIEW_MODE'
};


// WEBPACK FOOTER //
// ./src/snapfish/actions/snapfish-action-types.js